<template>
    <div class="footer_container">
       <div class="main_footer">
         <div class="footer_left">
           <ul>
             <li>
               <img src="../assets/images/android.png" alt=""><br>
               <span>安卓用户下载</span>
             </li>
             <li>
               <img src="../assets/images/apple.png" alt=""><br>
               <span>苹果用户下载</span>
             </li>
             <li>
               <img src="../assets/images/public.png" alt=""><br>
               <span>益企营公众号</span>
             </li>
           </ul>
           <b class="footer_line"></b>
         </div>

         <div class="footer_right">
           <div class="footer_center">
             <span>客服服务热线：</span>
             <p><strong>0755-86681611</strong><span>周一至周五（9:00-18:00）</span></p>
             <span>客服经理：18948329683</span>

           </div>
           <ul class="company_address">
             <li><span>企业地址：</span>深圳市前海深港合作区妈湾十九单元03街坊信利康大厦17F</li>
             <li><span>邮政编码：</span>830011</li>
             <li><span>客服邮箱：</span>XIEYINGZHAO@BOSUM.COM</li>
             <li><span>备案号：</span><a href="http://beian.miit.gov.cn" target="_blank">粤ICP备2020087927号</a></li>
           </ul>
         </div>
       </div>
      <div class="footer_copy">
        <span>© Copyright 2012-{{currentYear}} | 深圳市博商探寻企业咨询有限公司</span>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'mainFooter',
        data:function(){
          return {
            currentYear:new Date().getFullYear()
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/mainFooter.vue